import React from 'react'
import Sucesso from './images/sucesso.png'
export const ImagemSucesso = () => <img src={Sucesso} alt="sucesso" />
